import { type TileJson } from "../types";

export function tileJsonToSourceLayer(tj?: TileJson, fallback = "districts_map_layer") {
  return tj?.vector_layers?.[0]?.id ?? fallback;
}

export interface ResolveTegolaLayerTilesOptions {
  fallbackToMapTiles?: boolean;
}

export function resolveTegolaLayerTiles(
  tileJson: TileJson | undefined,
  layerId: string,
  appendQuery: (tile: string) => string,
  options?: ResolveTegolaLayerTilesOptions,
): string[] {
  const fromLayers =
    tileJson?.vector_layers
      ?.filter((layer) => layer.id.includes(layerId))
      .flatMap((layer) => layer.tiles ?? []) ?? [];

  let base: string[] = [];
  if (fromLayers.length > 0) {
    base = fromLayers;
  } else if (options?.fallbackToMapTiles) {
    base = tileJson?.tiles ?? [];
  }

  return base.map(appendQuery);
}
